export default "__VITE_ASSET__6505fdd8__"